export const isBrowser = () => typeof window !== 'undefined';

export const isAbsoluteUrl = (url: string) => /^(?:[a-z+]+:)?\/\//i.test(url);
